import Icon from "../Icon";
import IconButton from "../IconButton";

const ICON_MAPPING = {
  error: "icon2-eh-debug",
  warning: "icon2-eh-info",
  success: "icon2-eh-good",
};

type Props = {
  type: "error" | "warning" | "success";
  message?: string | React.ReactNode[] | React.ReactNode;
  onClose: $TSFixMeFunction;
};

function NotificationAlert({ type, message, onClose }: Props) {
  return (
    <div
      id={`notification-alert-${type}`}
      className={`notification-alert notification-alert-${type}`}
    >
      <div className="notification-container">
        <Icon name={ICON_MAPPING[type]} />
        <span>{message}</span>
        <IconButton
          id="notification-alert-close-btn"
          icon="ico2-eh-cancel"
          onClick={onClose}
        />
      </div>
    </div>
  );
}

export default NotificationAlert;
